import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Global GSAP ScrollTrigger configuration
 *
 * ignoreMobileResize: true - Prevents ScrollTrigger from recalculating
 * trigger positions when the mobile address bar shows/hides.
 * This fixes the "jumpy" layout issue on mobile devices.
 */
ScrollTrigger.config({
  ignoreMobileResize: true,
});

export { gsap, ScrollTrigger };

